import React from 'react';
import moment from 'moment';

const TableRow = ({data, listData}) => {
    moment.locale('es');

    const getStringFromBoolean = (item) => {
        return item ? 'Sí' : 'No';
    };

    const getDate = (item) => {
        return new Date(item).toLocaleString();
    };

    return (
        <tr className="il-ld-tr">
            { listData?.map( ({att, component, isBoolean, isDate, className, width, center, onClick}, i)=> {
                return (
                <td key={i} onClick={onClick && onClick}
                    className={'il-ld-td-lender'} style={center ? {width: width, textAlign: 'center'} : {width: width}}>
                    { att && isBoolean && getStringFromBoolean(data[att])}
                    { att && isDate && getDate(data[att])}
                    { att && !isBoolean && !isDate && data[att]}
                    { component && component(data) }
                </td>
                );
            } ) }
        </tr>
    );
};

export default TableRow;
